import { render, staticRenderFns } from "./BusinessOwnership.vue?vue&type=template&id=36e3d5b2&"
import script from "./BusinessOwnership.vue?vue&type=script&lang=js&"
export * from "./BusinessOwnership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports